module.exports = __webpack_public_path__ + "static/media/kino.c67b48da.jpg";